import { render, staticRenderFns } from "./_settingsCard.vue?vue&type=template&id=cd8a7de8"
import script from "./_settingsCard.vue?vue&type=script&lang=js"
export * from "./_settingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports